export default "__VITE_ASSET__D5zcwbnl__"